import script from "./serving-size-calculator.vue?vue&type=script&setup=true&lang=js"
export * from "./serving-size-calculator.vue?vue&type=script&setup=true&lang=js"

import "./serving-size-calculator.vue?vue&type=style&index=0&id=34c32f1e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34c32f1e"]])

export default __exports__